import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/helpers/utils";
import { CardHeader } from "./CardHeader";
import { CardCover } from "./CardCover";
import { CardFooter } from "./CardFooter";
import { CardActions } from "./CardActions";
import { card } from "./CardStyle";
import { CardProvider } from "./CardContext";

export interface CardProps
  extends React.HTMLAttributes<HTMLElement>,
    VariantProps<typeof card> {
  children: React.ReactNode;
  cover?: React.ReactNode;
  actions?: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  cardContentClass?: string;
}

export const Card = ({
  children,
  bordered,
  hoverable,
  rounded,
  fullwidth,
  cover,
  actions,
  header,
  footer,
  className,
  cardContentClass = "p-4",
  ...props
}: CardProps) => {
  return (
    <CardProvider
      bordered={bordered}
      hoverable={hoverable}
      rounded={rounded}
      fullwidth={fullwidth}
    >
      <div
        {...props}
        className={cn(
          card({ bordered, hoverable, rounded, fullwidth }),
          className,
          "group"
        )}
      >
        {header}
        {cover}
        <div className={`relative h-full space-y-4 ${cardContentClass}`}>
          {children}
          {actions}
        </div>
        {footer}
      </div>
    </CardProvider>
  );
};

Card.Header = CardHeader;
Card.Cover = CardCover;
Card.Actions = CardActions;
Card.Footer = CardFooter;
